import './splitViewEmpty.css'
export function SplitViewEmpty() {
    return (
        <></>
    )
}